module.exports = __webpack_public_path__ + "img/26dfbfe.png";